import React from 'react';

import PhotoSessionCard from 'components/PhotoSessionCard';
import globalMessages from 'messages/globalMessages';

export const buildPhotoSessionItem = (intl) => (photoSession) => {
  const {
    dueDate: date,
    fixed: timeDependent,
    house,
    owner,
    id,
    status,
    dueDate,
    photoSender,
    hasProblem,
    rescheduleDeadline,
  } = photoSession;

  const label = timeDependent ? null : intl.formatMessage(globalMessages.flexible);
  const ContentComponent = (
    <PhotoSessionCard
      house={house}
      owner={owner}
      photoSessionId={String(id)}
      fixed={timeDependent}
      status={status}
      dueDate={dueDate}
      photoSender={photoSender}
      hasProblem={hasProblem}
      rescheduleDeadline={rescheduleDeadline}
    />
  );

  return {
    date,
    timeDependent,
    label,
    ContentComponent,
  };
};

export const buildPhotoSessionItems = ({ photoSessions, intl }) =>
  photoSessions.map(buildPhotoSessionItem(intl));
